import { F, ifElse, pipe } from 'ramda';
import { isBefore, isDate } from 'date-fns/fp';

import { fetchValue } from './util';

export default pipe(fetchValue, ifElse(isDate, isBefore(new Date()), F));
